import CustomAvatar from 'components/CustomAvatar/CustomAvatar';
import Business from '@material-ui/icons/Business';
import { BodyS } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/payments/topupStyle';
import { makeStyles } from '@material-ui/styles';
import { IAlternativeSelectItem } from 'components/AlternativeSelect/AlternativeSelect';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IValueProps {
	selectedAccount: IAlternativeSelectItem | null;
}

const Value = ({ selectedAccount }: IValueProps) => {
	const classes = useStyles();
	const isSelected = !!selectedAccount?.id;

	return (
		<div className={classes.selectedItem}>
			<CustomAvatar
				accountId={isSelected ? selectedAccount!.id! : undefined}
				alt="Company Logo"
				placeholderIcon={<Business />}
				customClasses={classes.selectedItemIcon}
			/>
			<BodyS disableMargin>{isSelected ? selectedAccount!.name : translate('all.organizations')}</BodyS>
		</div>
	);
};

export default Value;
